import { StatusPill, type StatusTone } from '@bb/ui';
import type { CampaignSummary } from '../../api/client.ts';

const LABELS: Record<CampaignSummary['status'] | 'idle', [string, StatusTone]> = {
  draft: ['Draft', 'neutral'],
  scheduled: ['Scheduled', 'info'],
  active: ['Active', 'success'],
  idle: ['Idle', 'warning'],
  paused: ['Paused', 'warning'],
  stopped: ['Stopped', 'danger'],
  completed: ['Completed', 'neutral'],
  archived: ['Archived', 'neutral'],
};

/** Status of a campaign; an active campaign without recent sends shows as Idle (BB-96). */
export function CampaignStatusBadge({ campaign }: { campaign: Pick<CampaignSummary, 'status' | 'idle'> }) {
  const [label, tone] = LABELS[campaign.idle ? 'idle' : campaign.status];
  return <StatusPill tone={tone}>{label}</StatusPill>;
}
